module.exports = __webpack_public_path__ + "img/activities.f09b5cd8.svg";